import React from 'react';
import { useFormContext } from 'react-hook-form';

const Step5Roof: React.FC = () => {
  const { register, formState: { errors } } = useFormContext();

  return (
    <div className="solar-form-grid">
      <div className="solar-form-group">
        <label htmlFor="roofType" className="solar-form-label">
          Roof Type
        </label>
        <select
          id="roofType"
          {...register('roofType')}
          className="solar-form-select"
        >
          <option value="">Select roof type</option>
          <option value="asphalt">Asphalt Shingles</option>
          <option value="metal">Metal</option>
          <option value="tile">Tile</option>
          <option value="flat">Flat</option>
        </select>
        {errors.roofType && (
          <p className="solar-form-error">{String(errors.roofType.message)}</p>
        )}
      </div>

      <div className="solar-form-group">
        <label htmlFor="roofAge" className="solar-form-label">
          Roof Age
        </label>
        <select
          id="roofAge"
          {...register('roofAge')}
          className="solar-form-select"
        >
          <option value="">Select roof age</option>
          <option value="0-5">0-5 years</option>
          <option value="5-10">5-10 years</option>
          <option value="10-15">10-15 years</option>
          <option value="15+">15+ years</option>
        </select>
        {errors.roofAge && (
          <p className="solar-form-error">{String(errors.roofAge.message)}</p>
        )}
      </div>
    </div>
  );
};

export default Step5Roof; 